import { motion } from "framer-motion";

export function TapeLabel({ children, className = "", style = {} }) {
  return (
    <span className={`tape text-[13px] font-bold ${className}`} style={style}>
      {children}
    </span>
  );
}

export function Stamp({ children, className = "" }) {
  return <span className={`stamp text-sm ${className}`}>{children}</span>;
}

export function Hint({ children, className = "" }) {
  return (
    <motion.p
      className={`hint-wiggle font-hand font-bold text-lg text-ink/80 ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1.2 }}
    >
      {children}
    </motion.p>
  );
}

// vintage wire rack shelf — parallel deck wires + raised front railing with struts
export function WireShelf({ className = "", style = {} }) {
  return (
    <svg className={className} style={style} viewBox="0 0 560 30" preserveAspectRatio="none" aria-hidden="true">
      {[5, 10, 15].map((y) => (
        <line key={y} x1="0" y1={y} x2="560" y2={y} stroke="#4A4356" strokeWidth="2.5" />
      ))}
      <line x1="0" y1="26" x2="560" y2="26" stroke="#3A3446" strokeWidth="5" strokeLinecap="round" />
      {Array.from({ length: 19 }, (_, i) => 14 + i * 30).map((x) => (
        <path key={x} d={`M${x} 26 q-1 -8 3 -10`} stroke="#3A3446" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      ))}
    </svg>
  );
}

export function Slot({ label, className = "", style = {} }) {
  return (
    <div className={`slot text-sm sm:text-base px-4 py-3 ${className}`} style={style}>
      {label}
    </div>
  );
}

export function Polaroid({ label, className = "", style = {}, src = null }) {
  return (
    <div className={`polaroid ${className}`} style={style}>
      {src ? (
        <img src={src} alt={label} className="block w-full h-full object-cover" />
      ) : (
        <div className="slot w-full h-full !rounded-lg flex flex-col items-center justify-center gap-1 p-1 overflow-hidden">
          <svg viewBox="0 0 80 80" className="w-3/4 h-3/4" aria-hidden="true">
            {/* doodle self-portrait placeholder */}
            <circle cx="40" cy="42" r="24" fill="#FFF3D6" stroke="var(--ink)" strokeWidth="3" />
            {/* wavy hair */}
            <path d="M18 34 Q20 14 40 14 Q60 14 62 34 Q56 24 51 30 Q47 20 40 25 Q33 20 29 30 Q24 24 18 34 Z"
              fill="var(--ink)" />
            {/* eyes */}
            <circle cx="32" cy="42" r="2.6" fill="var(--ink)" />
            <circle cx="48" cy="42" r="2.6" fill="var(--ink)" />
            {/* glasses */}
            <circle cx="32" cy="42" r="6.5" fill="none" stroke="var(--ink)" strokeWidth="2" />
            <circle cx="48" cy="42" r="6.5" fill="none" stroke="var(--ink)" strokeWidth="2" />
            <line x1="38.5" y1="42" x2="41.5" y2="42" stroke="var(--ink)" strokeWidth="2" />
            {/* blush */}
            <circle cx="27" cy="50" r="3" fill="#F4A7A7" opacity="0.8" />
            <circle cx="53" cy="50" r="3" fill="#F4A7A7" opacity="0.8" />
            {/* big smile */}
            <path d="M32 53 Q40 61 48 53" fill="none" stroke="var(--ink)" strokeWidth="2.5" strokeLinecap="round" />
            {/* sparkle */}
            <path d="M64 20 l2 5 5 2 -5 2 -2 5 -2 -5 -5 -2 5 -2 Z" fill="#F2B705" stroke="var(--ink)" strokeWidth="1.5" />
          </svg>
          <span className="text-[10px] leading-tight text-center" style={{ fontFamily: "inherit" }}>
            {label} · photo soon
          </span>
        </div>
      )}
    </div>
  );
}